// @flow
import * as types from './mutation-types'
import type { InvoiceState } from './index'
import type { InvoiceSummary } from '../../../types/invoice-summary'

export default {
  [types.SET_COMPANY_INVOICES_FOR_CURRENT_FILTER]: (state: InvoiceState, invoices: InvoiceSummary[]): void => {
    state.companyInvoicesForCurrentFilter = invoices
  },
  [types.SET_TOTAL_NO_COMPANY_INVOICES_FOR_CURRENT_FILTER]: (state: InvoiceState, count: number): void => {
    state.totalNoCompanyInvoicesForCurrentFilter = count
  },
  [types.SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER]: (state: InvoiceState, { number }: { number: number }): void => {
    state.companyInvoicesCurrentPageNumber = number
  },
  [types.SET_COMPANY_INVOICES_PAGE_SIZE]: (state: InvoiceState, number: number): void => {
    state.companyInvoicesPageSize = number
    let noPages = Math.ceil(state.totalNoCompanyInvoicesForCurrentFilter / number)
    if (state.companyInvoicesCurrentPageNumber >= noPages) {
      state.companyInvoicesCurrentPageNumber = noPages - 1
    }
  },
  [types.SET_COMPANY_INVOICES_ORDER_BY]: (state: InvoiceState, companyInvoicesOrderBy: ?string): void => {
    state.companyInvoicesOrderBy = companyInvoicesOrderBy
  },
  [types.SET_COMPANY_INVOICES_ORDER_DIRECTION]: (state: InvoiceState, companyInvoicesOrderDirection: ?string): void => {
    state.companyInvoicesOrderDirection = companyInvoicesOrderDirection
  },
  [types.SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER]: (state: InvoiceState, value: string): void => {
    state.companyInvoicesFilterInvoiceNumber = value
  },
  [types.SET_COMPANY_INVOICES_FILTER_INVOICE_DATE]: (state: InvoiceState, value: string): void => {
    state.companyInvoicesFilterInvoiceDate = value
  },
  [types.SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH]: (state: InvoiceState, value: string): void => {
    state.companyInvoicesFilterInvoiceMonth = value
  },
  [types.SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR]: (state: InvoiceState, value: string): void => {
    state.companyInvoicesFilterInvoiceYear = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/mutations.js